// tslint:disable:no-default-export no-unused-expression
// tslint:disable max-func-body-length
import { scrollToTopAlways, scrollToTopExceptInternal } from '../infrastructure/platform/routing';
import { BowtieScreen } from '../area/bowtie/bowtie-screen';
import { Case } from '../area/case';
import { CaseCreator } from '../area/case/create';
import { Draft } from '../area/case/draft';
import { CaseDuplicateCreator } from '../area/case/duplicate';
import { Editor } from '../area/case/edit';
import { DashboardRoute } from '../area/dashboard/dashboard-route';
import { ReportRoute } from '../area/company-report/report-route';
import { Startup } from '../area/startup/startup';
import { ImportView } from '../area/import/import-view';
import { AppSetting } from 'dependencies/appsettings';
import { Layout } from '../shell/default/layout';
import { FavouriteRoute } from '../area/favourite/favourite-route';

import * as React from 'react';
import { Route } from 'react-router';

import { routeConstants } from './route-constants';
import { UserEditView } from 'app/area/administration';
import { ChangeCaseType } from '../area/case/draft/change-casetype';
import { MyDownloads } from 'app/area/my-downloads/my-downloads';
import { RoleEditView } from 'app/area/administration/edit/role/role-edit';
import { RoleSearchView } from 'app/area/administration/list/roles/role-search';
import { UsersSearchView } from 'app/area/administration/list/users/user-search';

import { IndicatorFactorsBase } from 'app/area/indicator-factors/codetable-base';
import { IndicatorFactorsList } from 'app/area/indicator-factors/list/codetable-list';
import { IndicatorFactorsItem } from 'app/area/indicator-factors/item/codetable-item';

import { CodetableBase } from 'app/area/codetable/codetable-base';
import { CodetableList } from 'app/area/codetable/list/codetable-list';
import { CodetableItem } from 'app/area/codetable/item/codetable-item';

import { SelectSavedReportSelector } from 'app/area/saved-reports/select-saved-report';
import { CodeSelector } from 'app/area/code-selector/code-selector';
import { UserProfileView } from 'app/area/user-profile/user-profile';
import { Messages } from 'app/area/messages/messages';
import { withWaitForAccessInfo } from 'app/routes/wait-for-access-info';
import { AdministrationMessagesList } from 'app/area/messages-administration/list/messages-list';
import { AdministrationMessageForm } from 'app/area/messages-administration/form/message-form';
import { DashboardAdminList } from 'app/area/dashboard-administration/list/dashboard-admin-list';
import { DashboardForm } from 'app/area/dashboard-administration/form/dashboard-form';
import { DashboardSavedReports } from 'app/area/dashboard-administration/saved-reports/dashboard-saved-reports';
import { TextConfigurationList } from 'app/area/text-configuration/list/text-configuration-list';
import { CodeDescriptionList } from 'app/area/text-configuration/list/code-description-list';
import { TextConfigurationForm } from 'app/area/text-configuration/form/text-configuration-form';
import { SavedFavouriteRoute } from 'app/area/favourite/saved-favourite-route';
import { CreateFavouriteDraftRoute } from 'app/area/favourite/create-favourite-draft-route';
import { SavedReportRoute } from 'app/area/company-report/saved-report-route';
import { withSavedCompanyReport } from 'app/area/saved-reports/saved-company-report';
import { CreateCompanyReportFavouriteRoute } from 'app/area/company-report/create-company-report-favourite-route';

/**
 * > It's important to avoid nested routes whenever possible to reduce app complexity.
 *
 * Mapping URLs to areas and component views
 * See router docs at: https://github.com/reactjs/react-router/tree/master/docs
 */

const translations = AppSetting.Translations as any;
const texts = (translations || {}).app;
const NotFound: any = (props: any) => (<div>{texts && texts.logoutNotFoundError}</div>);// tslint:disable-line

export default (<Route component={Layout} >
  <Route path={routeConstants.startupView} components={{ body: Startup }} onEnter={scrollToTopAlways} />

  <Route path={routeConstants.favouriteView} components={{ body: FavouriteRoute }} />
  <Route path={routeConstants.createFavouriteDraft} components={{ body: CreateFavouriteDraftRoute }} />
  <Route path={routeConstants.favouriteDraftNew} components={{ body: CreateFavouriteDraftRoute }} />
  <Route path={routeConstants.savedFavourite} components={{ body: SavedFavouriteRoute }} />

  <Route path={routeConstants.caseView} components={{ body: Case }} onEnter={scrollToTopExceptInternal} />
  <Route path={routeConstants.draftView} components={{ body: Draft }} onEnter={scrollToTopExceptInternal} />
  <Route path={routeConstants.createDraft} components={{ body: CaseCreator() }} />
  <Route path={routeConstants.changeCaseType} components={{ body: ChangeCaseType }} />
  <Route path={routeConstants.caseEdit} components={{ body: Editor() }} />
  <Route path={routeConstants.caseDuplicate} components={{ body: CaseDuplicateCreator }} />
  <Route path={routeConstants.dashboardView} components={{ body: DashboardRoute }} />

  <Route path={routeConstants.companyReportFavourite} components={{ body: CreateCompanyReportFavouriteRoute }} />
  <Route path={routeConstants.companyReportFavouriteDraft} components={{ body: ReportRoute }} />
  <Route path={routeConstants.companyReportView} components={{ body: ReportRoute }} />
  <Route path={routeConstants.savedCompanyReport} components={{ body: SavedReportRoute }} />

  <Route path={routeConstants.userProfileMainView} components={{ body: UserProfileView }} />
  <Route path={routeConstants.userProfileMainViewFocus} components={{ body: UserProfileView }} />
  <Route path={routeConstants.userSearchView} components={{ body: withWaitForAccessInfo(UsersSearchView) }} onEnter={scrollToTopAlways} />
  <Route path={routeConstants.rolesView} components={{ body: withWaitForAccessInfo(RoleSearchView) }} onEnter={scrollToTopAlways} />
  <Route path={routeConstants.bowtieView} components={{ body: BowtieScreen }} />

  <Route path={routeConstants.codetableAdministration} components={{ body: CodetableBase }}>
    <Route path={routeConstants.codetableAdministrationCode} components={{ body: CodetableItem }} onEnter={scrollToTopAlways} />
    <Route path={routeConstants.codetableAdministrationCodeActionType} components={{ body: CodetableItem }} onEnter={scrollToTopAlways} />
    <Route path={routeConstants.codetableAdministrationAddCode} components={{ body: CodetableItem }} onEnter={scrollToTopAlways} />
    <Route path={routeConstants.codetableAdministrationOptionsCollection}
      components={{ body: CodetableList }}
      onEnter={scrollToTopAlways} />
  </Route>

  <Route path={routeConstants.indicatorFactorsAdministration} components={{ body: IndicatorFactorsBase }}>
    <Route path={routeConstants.indicatorFactorsAdministrationCode}
      components={{ body: IndicatorFactorsItem }} onEnter={scrollToTopAlways} />
    <Route path={routeConstants.indicatorFactorsAdministrationCodeActionType}
      components={{ body: IndicatorFactorsItem }} onEnter={scrollToTopAlways} />
    <Route path={routeConstants.indicatorFactorsAdministrationAddCode}
      components={{ body: IndicatorFactorsItem }} onEnter={scrollToTopAlways} />
    <Route path={routeConstants.indicatorFactorsAdministrationOptionsCollection}
      components={{ body: IndicatorFactorsList }}
      onEnter={scrollToTopAlways} />
  </Route>

  <Route path={routeConstants.userAdd} components={{ body: withWaitForAccessInfo(UserEditView) }} onEnter={scrollToTopAlways} />
  <Route path={routeConstants.userEdit} components={{ body: withWaitForAccessInfo(UserEditView) }} onEnter={scrollToTopAlways} />
  <Route path={routeConstants.userDuplicate} components={{ body: withWaitForAccessInfo(UserEditView) }} onEnter={scrollToTopAlways} />

  <Route path={routeConstants.roleAdd} components={{ body: withWaitForAccessInfo(RoleEditView) }} onEnter={scrollToTopAlways} />
  <Route path={routeConstants.roleEdit} components={{ body: withWaitForAccessInfo(RoleEditView) }} onEnter={scrollToTopAlways} />
  <Route path={routeConstants.roleDuplicate} components={{ body: withWaitForAccessInfo(RoleEditView) }} onEnter={scrollToTopAlways} />

  <Route path={routeConstants.textConfigurationList}
    components={{ body: withWaitForAccessInfo(TextConfigurationList) }}
    onEnter={scrollToTopAlways} />
  <Route path={routeConstants.textConfigurationAdd}
    components={{ body: withWaitForAccessInfo(TextConfigurationForm) }}
    onEnter={scrollToTopAlways} />
  <Route path={routeConstants.textConfigurationItem}
    components={{ body: withWaitForAccessInfo(TextConfigurationForm) }}
    onEnter={scrollToTopAlways} />

  <Route path={routeConstants.codeDescriptionList}
    components={{ body: withWaitForAccessInfo(CodeDescriptionList) }}
    onEnter={scrollToTopAlways} />

  <Route path={routeConstants.myDownloadsView} components={{ body: MyDownloads }} onEnter={scrollToTopAlways} />
  <Route path={routeConstants.importView} components={{ body: ImportView }} onEnter={scrollToTopAlways} />
  <Route path={routeConstants.messagesToUserView} components={{ body: Messages }} onEnter={scrollToTopAlways} />

  <Route path={routeConstants.administrationMessagesList}
    components={{ body: withWaitForAccessInfo(AdministrationMessagesList) }}
    onEnter={scrollToTopAlways} />
  <Route path={routeConstants.administrationMessagesItem}
    components={{ body: withWaitForAccessInfo(AdministrationMessageForm) }}
    onEnter={scrollToTopAlways} />

  <Route path={routeConstants.dashboardAdminList}
    components={{ body: withWaitForAccessInfo(DashboardAdminList) }}
    onEnter={scrollToTopAlways} />
  <Route path={routeConstants.dashboardAdminItem}
    components={{ body: withWaitForAccessInfo(DashboardForm) }}
    onEnter={scrollToTopAlways} />
  <Route path={routeConstants.dashboardAdminSavedReports}
    components={{ body: withWaitForAccessInfo(DashboardSavedReports) }}
    onEnter={scrollToTopAlways} />

  <Route path={routeConstants.selectSavedReports} components={{ body: SelectSavedReportSelector }} />
  <Route path={routeConstants.selectSavedCompanyReports} components={{ body: withSavedCompanyReport(SelectSavedReportSelector) }} />
  <Route path={routeConstants.select} components={{ body: CodeSelector }} />
  <Route path={routeConstants.selectCodetableId} components={{ body: CodeSelector }} />
  <Route path="*" components={{ body: NotFound }} />
</Route>);

// Allow hot reloading of routes
declare var module: any;
if (module.hot) {
  module.hot.accept();
}
